import React from 'react'

import { Md } from './styles'

const Markdown = ({ text }) => (
  <Md dangerouslySetInnerHTML={{ __html: text.childMarkdownRemark.html }} />
)

export default Markdown
